var RedactionShapeView = require('../redactionShape'),
    FloatingCodesController = require('./controller');

require('../../../../../../plugin/raphael.connection');


// this.selectedCodes
// (these can be null)
    // this.connection
    // reasonCodeUiModel -- this the same as that on the code letters; set from the 'controller'

module.exports = RedactionShapeView.extend({
    initialize: function(options) {

        RedactionShapeView.prototype.initialize.apply(this, arguments);

        this.listenTo( this.selectedCodes, 'add remove reset', this._updateReasonCodeViewAndConnection );

        this.listenTo( this, 'shape.move shape.resizeRect shape.redaction.poly.resizeEnd shape.redaction.poly.resize', this.onAfterMoveOrResize );

        if ( !this.pgNoteModel.floatingCodesController ) {
            this.pgNoteModel['floatingCodesController'] = new FloatingCodesController( this.options.channel, this.pgNoteModel );
        }

        /*
        * Whenever there is a connection, there should always be a reasonCodeUiModel.
        * However, I've encountered a circumstance where this is not the case -- see comment in _setConnectionStrokeWidthAndDashArray.
        * This should be cleanup up and fixed.
        * */

        this.connection = null;
        this.reasonCodeUiModel = null;

        // Flags to determine whether to draw a new box from existing points for notes that have been saved.
        // Probably belong on the shape models ... TODO: yes put on the model
        this.originalUniqueReasonCodeString = this.selectedCodes.getCodesAsString();

        // Always set on _updateReasonCodeViewAndConnection, though set here redundantly for clarity.
        this.nLastSelectedCodes = this.selectedCodes.length;

    },
    onAfterRender: function() {

        this.pgNoteModel.floatingCodesController.addShapeView( this );
        this._updateReasonCodeViewAndConnection();
        this.connection && this.scaleConnection( this.options.scale ); // just put this in update/create ?

    },

    _updateReasonCodeViewAndConnection: function() {

        this.pgNoteModel.floatingCodesController.update( this, this.selectedCodes.getCodesAsString() );
        this.nLastSelectedCodes = this.selectedCodes.length;

    },

    createConnection: function(codeLettersView) {

        var paper = this.shapeUI.getRaphaelElPaper();

        this.connection =
            paper.connection( this.el, codeLettersView.el, this.reasonCodeUiModel.getConnectionLineColor() );

        this.connection.line.attr( this.reasonCodeUiModel.getConnectionLineAttrs() );

        this._setConnectionStrokeWidthAndDashArray( this.channel.request('currentScaleValue') ); 

    },
    
    onAfterMoveOrResize: function(elBox) {

        /*
        * Forward to the uiModel which is shared parents with the same codes
        * -- there is no one parent to many child relationship anymore.
        * Position the corresponding codes view if it's not set, then update this connection.
        * ( No need to update other potential shape view connections b/c if the codeView moves with this;
        *  ... once 2 shape views are attached, codesWerePositioned is set to true ).
        * DVBC-1589: hack -- if event chain leading to this fn don't provide the bounding box,
        * calc it here; really should go through and clean up the event chain ...
        * */
        var rcm = this.reasonCodeUiModel;

        if ( rcm && !rcm.get('codesWerePositioned') ) {
            rcm.trigger('updatePositionToMatchShapeView', elBox || this.el.getBBox() );
        }

        this.updateConnection();

    },

    updateConnection: function() {

        if (!this.connection)
            return;

        var paper = this.shapeUI.getRaphaelElPaper(), // TODO: cache candidate (?)... but then ref issues
            connection = this.connection;

        paper.connection( connection );

    },

    scaleConnection: function(scale) {

        if (!this.connection)
            return;

        this.updateConnection();  
        
        this._setConnectionStrokeWidthAndDashArray(scale);
     
    },

    /*
    * 2 hacks for scaling not working with stroke-width and dash array on transformed elements.
    * Can probably eliminate if/when implement a viewbox.
    * Stroke-width: Raphael transform doesn't touch it -- see code.
    * Stroke-width hack also done in codeBox view (there, done in overall 'transform')
    * Dash-Array: bypass Raphael.attr -- its formula takes stroke-width and some other factors into account.
    * Maybe want to extend Raphael / use attribute for these if end up using in > 1 place ...
    * Potential for optimization here ... especially when called on scale when scale is 'Fit Width'
    * */
    _setConnectionStrokeWidthAndDashArray: function(scale) {

        /*
        * Exit immediately if there is no reasonCodeUiModel --
        * this is a quick HACK for a bug encountered where the view can have a connection but not a reasonCodeUiModel --
        * this should never be the case but I don't want to break anything and discovering the fix is quick complicated ...
        * I'd need to go through the entire rendering logic for the note type.
        * ! THIS REALLY SHOULD BE FIXED AT SOME POINT !
        * To reproduce:
        *   - create 2 shapes each with 2 reasonCodes pointing to the same codeView
        *   - remove a reason code from one so it's no longer connected to the same codeView
        *   - then add back the same reason code so it's connected again
        *   - then change the scale
        *   - now this.connection will exist but this.reasonCodeUiModel will be null
        * */

        if ( !this.reasonCodeUiModel )
            return;

        var connectionWidth = this.reasonCodeUiModel.getConnectionLineWidth(),
            connectionLine = this.connection.line;

        connectionLine.attr( 'stroke-width', +(connectionWidth * scale).toFixed(3) );

        // Only apply the dash-array value if it isn't null (the line is not dotted),
        // for a bit of a performance boast in that case.
        var dashArray = this.reasonCodeUiModel.getConnectionDashArraySVGValue(scale);
        if (dashArray) 
            connectionLine.node.setAttribute( 'stroke-dasharray',  dashArray);
        
    },

    onAfterButtonSetCreation: function() {
        RedactionShapeView.prototype.onAfterButtonSetCreation.apply(this, arguments);

        // Should be mediated but get going with this for now
        // Only want to call for the code views of this note
        // use paper.top -- it will be the topmost element in the selectSet
        this.pgNoteModel.floatingCodesController.moveCodeViewsToFrontOfCanvas( this.shapeUI.getRaphaelElPaper() );
    },

    destroyConnection: function() {
        //  will prob need to write a wrapper around connection eventually ...
        if ( !this.connection )
            return;

        this.connection.line.remove();
        this.connection = null;
    },

    // Ensure Code Boxes Remain In Front on the Shapes
    bringToFront: function() {
        RedactionShapeView.prototype.bringToFront.apply( this, arguments );
        this.channel.trigger('imgCanvas.moveAllCodeBoxesToFront', this.paper);
    },

    /*
    * Don't just clean up this view, but utilize the destroy call from
    * other areas in canvas workflow to destroy the floatingCodesController, if it exists.
    * */
    onBeforeDestroy: function(manualUserDelete) {

        RedactionShapeView.prototype.onBeforeDestroy.apply( this, arguments );
        this.stopListening();

        // Always remove this view from the controller -- would really
        // only want to remove manualUserDelete (delete btn / hotkey) , but if it's not,
        // the shapeView will still exist floatingCodesController.destroy and recursion will occur.
        this.pgNoteModel.floatingCodesController.removeShapeView(this);

        if (!manualUserDelete && this.pgNoteModel.floatingCodesController) {

            this.pgNoteModel.floatingCodesController.destroy();
            delete this.pgNoteModel.floatingCodesController;
        }

    }

});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/redaction/floatingCodes/shapeView.js
 ** module id = 244
 ** module chunks = 0
 **/